import { currentSeason, rankFor, XP_PER_TIER } from '@aleaces/engine';
import { useProfile } from '../hooks';
import { levelOf } from '../profile';

export type MenuScreenId = 'menu' | 'pass' | 'collection' | 'profile';

const NAV: { id: MenuScreenId; label: string }[] = [
  { id: 'menu', label: 'Taverne' },
  { id: 'pass', label: 'Battlepass' },
  { id: 'collection', label: 'Sammlung' },
  { id: 'profile', label: 'Profil' },
];

export function TopBar({ screen, onNavigate }: { screen: MenuScreenId; onNavigate: (s: MenuScreenId) => void }) {
  const p = useProfile();
  if (!p) return null;
  const lvl = levelOf(p.xp);
  const into = p.xp % XP_PER_TIER;
  const rk = rankFor(p.rating);
  const season = currentSeason();
  const days = Math.max(0, Math.ceil((season.end.getTime() - Date.now()) / 86400000));
  return (
    <header className="topbar">
      <div className="logo">
        Ale &amp; Aces<small>Tavernen-Hold'em</small>
      </div>
      <div className="pill">
        <span className="ic" style={{ background: 'var(--gold)' }}>S{season.num}</span>
        <span>Saison <b>{days} Tage</b></span>
      </div>
      <div className="pill">
        <span className="ic" style={{ background: rk.color }}>{rk.name[0]}</span>
        <span><b>{rk.name}</b> · {p.rating}</span>
      </div>
      <div className="xpwrap">
        <div className="lbl">
          <span>Stufe <b>{lvl}</b></span>
          <span>{into} / {XP_PER_TIER} EP</span>
        </div>
        <div className="bar"><i style={{ width: (into / XP_PER_TIER) * 100 + '%' }} /></div>
      </div>
      <div className="pill">
        <span className="ic" style={{ background: 'var(--gold-hi)' }}>T</span>
        <span className="taler">{p.taler}</span>&nbsp;Taler
      </div>
      <nav className="nav">
        {NAV.map((n) => (
          <button key={n.id} className={screen === n.id ? 'active' : ''} onClick={() => onNavigate(n.id)}>
            {n.label}
          </button>
        ))}
      </nav>
    </header>
  );
}
